<template>
	<div id="page-description">

		<section class="main-description-section">
			<div class="container oversized-container">

				<breadcrumbs :crumbs="[{ link: '/', label: 'Inicio' }, { link: '/pages', label: 'Comunicados y noticias' }, { label: page.titulo }]" />

				<div class="content-text">
					<api-img :comp="page.imagenes_id" class="page-image" :image-descriptor="page.extracto" />
					{{ page.descripcion }}
				</div>
			</div>
		</section>

	</div>
</template>

<script>
import Breadcrumbs from '../daniel/breadcrumbs'
import _ from 'lodash'
import { mapGetters } from "vuex";
import { notify } from "@/js/utils.js";

export default {
	components: { Breadcrumbs },
	name: 'PageDescription',
	data() {
		return {
			quantity: 1,

			page: {
				id: null,
				imagenes_id: null,
				titulo: null,
				extracto: null,
				descripcion: null,
				created: null,
				estatus: null,
				tipo: null,
				modified: null,
			},

			// == Carousels options ==
			swiperOptionTop: {
				loop: true,
				loopedSlides: 5, // looped slides should be the same
				spaceBetween: 10,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			// == ==
		};
	},

	computed: {
		...mapGetters(["catalogosGetComunicados"]),
	},

	methods: {
		async getPage() {
			try {
				this.page = _.find(this.catalogosGetComunicados, { id: this.$route.params.id })
			} catch (e) {
				console.error(e);
				notify(e)
			}
		}
	},

	mounted() {
		this.getPage();
	},

	watch: {
		"$route.params.id": function (v) {
			// this.id = this.$root._getURLID(this.$route.params.id);
			this.getPage();
		},
	},
};
</script>

<style lang="scss">
#page-description {
	.container {
		display: block;

		.content-text {
			display: inline-block;
			width: 100%;
			@media screen and (max-width: 768px) {
				text-align: center;
				margin-bottom: 32px;
			}
		}

		.page-image {
			float: right;
			clear: both;
			width: 40vw;
			max-width: 24em;
			margin-bottom: 32px;
			border-radius: 5px;
			@media screen and (max-width: 768px) {
				float: none;
				clear: none;
				display: block;
				margin: 0 auto;
				margin-bottom: 32px;
				width: 100%;	
			}
		}
	}
}
</style>